import * as actionTypes from './actionTypes';
import axios from '../../services/axios'
import {setMessage} from './message';

export const loadCurrentWeekNumber = () => {
    return {
        type: actionTypes.LOAD_CURRENT_WEEK
    }
}

export const setCurrentWeekNumber = (currentWeekNumber) => {
    return {
        type: actionTypes.SET_CURRENT_WEEK,
        currentWeekNumber: currentWeekNumber
    }
}

export const getCurrentWeekNumber = () => {
    return (dispatch) => {
        dispatch(loadCurrentWeekNumber())
        axios.get(`/api/v1/schedule/current-week`)
            .then(response => {
                dispatch(setCurrentWeekNumber(response.data))
            })
            .catch(() => {
                dispatch(setMessage({ type: 'warning', text: "Не удалось определить текущую неделю." }))
            });
    }
}

export const loadEmployees = () => {
    return {
        type: actionTypes.LOAD_EMPLOYEES
    }
}

export const setEmployees = (employeesData) => {
    return {
        type: actionTypes.SET_EMPLOYEES,
        employeesData: employeesData
    }
}

export const getEmployees = (searchText) => {
    return dispatch => {
        dispatch(loadEmployees())
        axios.get(`/api/v1/employees/fio?employee-fio=${searchText}`)
            .then(response => {
                dispatch(setEmployees(response.data))
            })
            .catch(() => {
                dispatch(setEmployees([]))
                dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
            });
    }
}

export const loadEmployee = () => {
    return {
        type: actionTypes.LOAD_EMPLOYEE
    }
}

export const setEmployee = (employee) => {
    return {
        type: actionTypes.SET_EMPLOYEE,
        employee: employee
    }
}

export const getEmployee = (urlId) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch(loadEmployee())
        axios
            .get(`/api/v1/employees/${urlId}`)
            .then((response) => {
                dispatch(setEmployee(response.data))

                resolve(response.data);
            })
            .catch((error) => {
                dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
                reject(error);
            });
    });

export const loadEmployeeSchedule = () => {
    return {
        type: actionTypes.LOAD_EMPLOYEE_SCHEDULE
    }
}

export const setEmployeeSchedule = (employeeSchedule) => {
    return {
        type: actionTypes.SET_EMPLOYEE_SCHEDULE,
        employeeSchedule: employeeSchedule
    }
}

export const getEmployeeSchedule = (urlId) => {
    return dispatch => {
        dispatch(loadEmployeeSchedule())
        return axios.get(`/api/v1/employees/schedule/${urlId}`)
            .then(response => {
                dispatch(setEmployeeSchedule(response.data));
                return response.data;
            })
            .catch((error) => {
                dispatch(setEmployeeSchedule(error))
                if (error?.response?.status !== 404) {
                    dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
                }
                return Promise.reject(error);
            });
    }
}

export const loadEmployeeAnnouncements = () => {
    return {
        type: actionTypes.LOAD_EMPLOYEE_ANNOUNCEMENTS
    }
}

export const setEmployeeAnnouncements = (announcements) => {
    return {
        type: actionTypes.SET_EMPLOYEE_ANNOUNCEMENTS,
        announcements: announcements
    }
}

export const getEmployeeAnnouncements = (id) => {
    return dispatch => {
        dispatch(loadEmployeeAnnouncements())
        axios.get(`/api/v1/announcements/employees?url-id=${id}`)
            .then(response => {
                dispatch(setEmployeeAnnouncements(response.data))
            })
            .catch(() => {
                dispatch(setMessage({ type: 'warning', text: "Не удалось загрузить объявления." }))
            });
    }
}

export const waitScheduleDownload = (targetDownload) => {
    return {
        type: actionTypes.WAIT_SCHEDULE_DOWNLOAD,
        targetDownload: targetDownload
    }
}

export const setScheduleDownload = (targetDownload) => {
    return {
        type: actionTypes.SET_SCHEDULE_DOWNLOAD,
        targetDownload: targetDownload
    }
}

export const getScheduleDownload = (id, url, defaultFileName, targetDownload) => {
    return dispatch => {
        dispatch(waitScheduleDownload(targetDownload))
        axios({
            url: `${url}${id}`,
            method: 'GET',
            responseType: 'blob',
            headers: {
                'Accept': 'application/vnd.ms-excel',
                'Content-Type': 'application/json;charset=UTF-8'
            }
        }).then((response) => {
            let fileName = response.headers['file-name'];
            fileName = fileName ? decodeURIComponent(fileName) : defaultFileName;
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${fileName}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url)

            dispatch(setScheduleDownload(targetDownload))
        }).catch(() => {
            dispatch(setMessage({ type: 'warning', text: "Не удалось скачать файл." }))
        })
    }
}

export const loadGroupSchedule = () => {
    return {
        type: actionTypes.LOAD_GROUP_SCHEDULE
    }
}

export const setGroupSchedule = (groupSchedule) => {
    return {
        type: actionTypes.SET_GROUP_SCHEDULE,
        groupSchedule: groupSchedule
    }
}

export const getGroupSchedule = (groupNumber) => {
    return dispatch => {
        dispatch(loadGroupSchedule())
        return axios.get(`/api/v1/schedule?studentGroup=${groupNumber}`)
            .then(response => {
                dispatch(setGroupSchedule(response.data));
                return response.data;
            })
            .catch(error => {
                dispatch(setGroupSchedule(error))
                if (error?.response?.status !== 404) {
                    dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
                }
                return Promise.reject(error);
            });
    }
}

export const loadGroupAnnouncements = () => {
    return {
        type: actionTypes.LOAD_GROUP_ANNOUNCEMENTS
    }
}

export const setGroupAnnouncements = (announcements) => {
    return {
        type: actionTypes.SET_GROUP_ANNOUNCEMENTS,
        announcements: announcements
    }
}

export const getGroupAnnouncements = (id) => {
    return dispatch => {
        dispatch(loadGroupAnnouncements())
        axios.get(`/api/v1/announcements/student-groups?name=${id}`)
            .then(response => {
                dispatch(setGroupAnnouncements(response.data))
            })
            .catch(() => {
                dispatch(setMessage({ type: 'warning', text: "Не удалось загрузить объявления." }))
            });
    }
}

export const getGroupsByNameRequest = () => {
    return {
        type: actionTypes.GET_GROUPS_BY_NAME_REQUEST,
    }
}

export const getGroupsByNameSuccess = (groups) => {
    return {
        type: actionTypes.GET_GROUPS_BY_NAME_SUCCESS,
        payload: groups,
    }
}

export const getGroupsByNameFailure = () => {
    return {
        type: actionTypes.GET_GROUPS_BY_NAME_FAILURE,
    }
}

export const getGroupsByName = (name) => {
    return dispatch => {
        dispatch(getGroupsByNameRequest())
        axios.get(`/api/v1/student-groups/filters?name=${name}`)
            .then(response => {
                dispatch(getGroupsByNameSuccess(response.data))
            })
            .catch(() => {
                dispatch(getGroupsByNameFailure());
                dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
            });
    }
}

export const setWeekFilters = (value) => {
    return {
        type: actionTypes.SET_WEEK_FILTERS,
        weekFilters: [...value]
    }
}